var map = {
	".": "aNS5",
	"./": "aNS5",
	"./1.png": "e718",
	"./copy": "wR+y",
	"./copy.vue": "wR+y",
	"./dayi": "fupX",
	"./dayi.vue": "fupX",
	"./img/1.png": "DMPp",
	"./img/2.png": "bNDr",
	"./img/3.png": "jv3t",
	"./img/arrow.png": "apMH",
	"./img/arrow_on.png": "4nQP",
	"./img/attach/audio.png": "hMyb",
	"./img/attach/audio_on.png": "E/pB",
	"./img/attach/excel.png": "QSov",
	"./img/attach/excel_on.png": "3meW",
	"./img/attach/other.png": "Dp0h",
	"./img/attach/other_on.png": "XVYZ",
	"./img/attach/pdf.png": "ytUJ",
	"./img/attach/pdf_on.png": "DLfN",
	"./img/attach/pic.png": "EgmZ",
	"./img/attach/pic_on.png": "CME0",
	"./img/attach/video.png": "18vn",
	"./img/attach/video_on.png": "Gc4a",
	"./img/attach/word.png": "D2rn",
	"./img/attach/word_on.png": "SJwq",
	"./img/blue/1.png": "YHYl",
	"./img/blue/10.png": "l8MM",
	"./img/blue/11.png": "pzoT",
	"./img/blue/12.png": "GbNW",
	"./img/blue/13.png": "mDbF",
	"./img/blue/14.png": "EXlC",
	"./img/blue/15.png": "Id4m",
	"./img/blue/16.png": "MjQj",
	"./img/blue/17.png": "OPzB",
	"./img/blue/18.png": "xDjS",
	"./img/blue/19.png": "r54R",
	"./img/blue/2.png": "q/sF",
	"./img/blue/20.png": "Knn+",
	"./img/blue/3.png": "fB3r",
	"./img/blue/4.png": "Fzgb",
	"./img/blue/5.png": "daUw",
	"./img/blue/6.png": "tUMj",
	"./img/blue/7.png": "3CiX",
	"./img/blue/8.png": "uQJ+",
	"./img/blue/9.png": "few4",
	"./img/cancel.png": "cXQd",
	"./img/cancel_on.png": "DYYQ",
	"./img/clear.png": "uJSi",
	"./img/clear_on.png": "ReYj",
	"./img/comments.png": "CHDQ",
	"./img/comments_on.png": "gWTP",
	"./img/eraser.png": "JJv3",
	"./img/eraser_on.png": "yFAF",
	"./img/green/1.png": "eI3m",
	"./img/green/10.png": "ACpm",
	"./img/green/11.png": "OY/2",
	"./img/green/12.png": "vqYV",
	"./img/green/13.png": "VcCs",
	"./img/green/14.png": "sZtY",
	"./img/green/15.png": "CjyC",
	"./img/green/16.png": "n9wV",
	"./img/green/17.png": "IW9u",
	"./img/green/18.png": "UVTw",
	"./img/green/19.png": "gA7i",
	"./img/green/2.png": "x5WX",
	"./img/green/20.png": "N6zt",
	"./img/green/3.png": "bCrn",
	"./img/green/4.png": "dEk4",
	"./img/green/5.png": "1Avm",
	"./img/green/6.png": "5NF9",
	"./img/green/7.png": "x7sG",
	"./img/green/8.png": "AQt9",
	"./img/green/9.png": "FOuj",
	"./img/grey/1.png": "mFNo",
	"./img/grey/10.png": "NwoF",
	"./img/grey/11.png": "Mbq1",
	"./img/grey/12.png": "YaWI",
	"./img/grey/13.png": "TI0d",
	"./img/grey/14.png": "kFWV",
	"./img/grey/15.png": "qvhc",
	"./img/grey/16.png": "DwCk",
	"./img/grey/17.png": "oesk",
	"./img/grey/18.png": "eKqT",
	"./img/grey/19.png": "Mc7l",
	"./img/grey/2.png": "8xL8",
	"./img/grey/20.png": "dF+Y",
	"./img/grey/3.png": "6B09",
	"./img/grey/4.png": "kO4M",
	"./img/grey/5.png": "1sto",
	"./img/grey/6.png": "H1fN",
	"./img/grey/7.png": "xpwE",
	"./img/grey/8.png": "jtYN",
	"./img/grey/9.png": "ohH2",
	"./img/help.png": "7Sah",
	"./img/highlight.png": "QIs1",
	"./img/highlight_on.png": "0YMd",
	"./img/line.png": "GhtK",
	"./img/line_on.png": "qKoL",
	"./img/move.png": "9eJW",
	"./img/move_on.png": "HqHY",
	"./img/paint.png": "mlFG",
	"./img/paint_on.png": "VN+O",
	"./img/pencil.ico": "9GAN",
	"./img/rect.png": "IOpl",
	"./img/rect_on.png": "HozR",
	"./img/red/1.png": "fFKI",
	"./img/red/10.png": "lXzW",
	"./img/red/11.png": "H+TN",
	"./img/red/12.png": "yO97",
	"./img/red/13.png": "m1Fs",
	"./img/red/14.png": "a4Jl",
	"./img/red/15.png": "FSi+",
	"./img/red/16.png": "TCqN",
	"./img/red/17.png": "Wsu5",
	"./img/red/18.png": "DCVH",
	"./img/red/19.png": "UUvX",
	"./img/red/2.png": "zgNG",
	"./img/red/20.png": "QcEh",
	"./img/red/3.png": "Aq0r",
	"./img/red/4.png": "Zxpm",
	"./img/red/5.png": "CA8q",
	"./img/red/6.png": "G2we",
	"./img/red/7.png": "X2xP",
	"./img/red/8.png": "hniB",
	"./img/red/9.png": "w0Ct",
	"./img/rotate.png": "S4ZN",
	"./img/rotate_on.png": "9S8g",
	"./img/tag.png": "fS6l",
	"./img/tag_on.png": "MX1X",
	"./img/white/1.png": "4FXB",
	"./img/white/10.png": "M0tp",
	"./img/white/11.png": "6zSw",
	"./img/white/12.png": "7mi7",
	"./img/white/13.png": "ImIV",
	"./img/white/14.png": "Cx43",
	"./img/white/15.png": "V5yG",
	"./img/white/16.png": "UNyF",
	"./img/white/17.png": "eirC",
	"./img/white/18.png": "gVIt",
	"./img/white/19.png": "FyKP",
	"./img/white/2.png": "nnqG",
	"./img/white/20.png": "zrI+",
	"./img/white/3.png": "aLJP",
	"./img/white/4.png": "z830",
	"./img/white/5.png": "hAF/",
	"./img/white/6.png": "tsrU",
	"./img/white/7.png": "UfnX",
	"./img/white/8.png": "Hq6d",
	"./img/white/9.png": "nvlz",
	"./img/yellow/1.png": "NIhq",
	"./img/yellow/10.png": "6CBn",
	"./img/yellow/11.png": "nq1R",
	"./img/yellow/12.png": "DBUq",
	"./img/yellow/13.png": "JPW2",
	"./img/yellow/14.png": "dlXf",
	"./img/yellow/15.png": "+Kk4",
	"./img/yellow/16.png": "26Na",
	"./img/yellow/17.png": "FAsX",
	"./img/yellow/18.png": "19C2",
	"./img/yellow/19.png": "fGUp",
	"./img/yellow/2.png": "xsVB",
	"./img/yellow/20.png": "OvMb",
	"./img/yellow/3.png": "UQRz",
	"./img/yellow/4.png": "PtHP",
	"./img/yellow/5.png": "YnPU",
	"./img/yellow/6.png": "z5Nh",
	"./img/yellow/7.png": "JPUR",
	"./img/yellow/8.png": "V0BJ",
	"./img/yellow/9.png": "TCqX",
	"./img/下拉.png": "mUJN",
	"./img/形状-选中.png": "OwyB",
	"./img/形状.png": "G2r/",
	"./img/选中.png": "uYYC",
	"./index": "aNS5",
	"./index.vue": "aNS5",
	"./mock": "4eYW",
	"./mock.json": "4eYW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "T2an";


//////////////////
// WEBPACK FOOTER
// ./src/pages/mark-paper ^.*$
// module id = T2an
// module chunks = 0